/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Metrics_Show_DurationInputs */

const en_options_metrics_show_duration = /** @type {(inputs: Options_Metrics_Show_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show Duration`)
};

const fr_options_metrics_show_duration = /** @type {(inputs: Options_Metrics_Show_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show Duration`)
};

const de_options_metrics_show_duration = /** @type {(inputs: Options_Metrics_Show_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show Duration`)
};

const it_options_metrics_show_duration = /** @type {(inputs: Options_Metrics_Show_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show Duration`)
};

const ru_options_metrics_show_duration = /** @type {(inputs: Options_Metrics_Show_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show Duration`)
};

const es_options_metrics_show_duration = /** @type {(inputs: Options_Metrics_Show_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show Duration`)
};

const zh_cn2_options_metrics_show_duration = /** @type {(inputs: Options_Metrics_Show_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show Duration`)
};

const ja_options_metrics_show_duration = /** @type {(inputs: Options_Metrics_Show_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show Duration`)
};

const hi_options_metrics_show_duration = /** @type {(inputs: Options_Metrics_Show_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show Duration`)
};

const pt_pt2_options_metrics_show_duration = /** @type {(inputs: Options_Metrics_Show_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show Duration`)
};

/**
* | output |
* | --- |
* | "Show Duration" |
*
* @param {Options_Metrics_Show_DurationInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_metrics_show_duration = /** @type {((inputs?: Options_Metrics_Show_DurationInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Metrics_Show_DurationInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_metrics_show_duration(inputs)
	if (locale === "de") return de_options_metrics_show_duration(inputs)
	if (locale === "it") return it_options_metrics_show_duration(inputs)
	if (locale === "ru") return ru_options_metrics_show_duration(inputs)
	if (locale === "es") return es_options_metrics_show_duration(inputs)
	if (locale === "zh-CN") return zh_cn2_options_metrics_show_duration(inputs)
	if (locale === "ja") return ja_options_metrics_show_duration(inputs)
	if (locale === "hi") return hi_options_metrics_show_duration(inputs)
	if (locale === "pt-PT") return pt_pt2_options_metrics_show_duration(inputs)
	return en_options_metrics_show_duration(inputs)
});